/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Playdata_Eventreport_Pain_Intro1Inputs */

const ja_playdata_eventreport_pain_intro1 = /** @type {(inputs: Playdata_Eventreport_Pain_Intro1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`今、こんなお悩みはありませんか？`)
};

const en_playdata_eventreport_pain_intro1 = /** @type {(inputs: Playdata_Eventreport_Pain_Intro1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Do any of these sound familiar?`)
};

/**
* | output |
* | --- |
* | "Do any of these sound familiar?" |
*
* @param {Playdata_Eventreport_Pain_Intro1Inputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
const playdata_eventreport_pain_intro1 = /** @type {((inputs?: Playdata_Eventreport_Pain_Intro1Inputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Playdata_Eventreport_Pain_Intro1Inputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_playdata_eventreport_pain_intro1(inputs)
	return en_playdata_eventreport_pain_intro1(inputs)
});
export { playdata_eventreport_pain_intro1 as "playdata_eventReport_pain_intro" }